import { EditOutlined } from '@ant-design/icons';
import { Input, Modal, Tooltip, message } from 'antd';
import { useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { updateTradeComment } from 'services/api/conversation';
import { sellerMemosLimit as limit } from 'views/Conversation/Sider/constants';

interface OrderRemarkProps {
  internalTradeId: number;
  platform: General.PlatformUpperCaseTunnel;
  content: string;
  showEdit?: boolean;
  onRefresh?: () => void;
}

export const OrderRemark = (props: OrderRemarkProps) => {
  const { internalTradeId, platform, content, showEdit = false, onRefresh } = props;
  const { t } = useTranslate();
  const [visible, setVisible] = useState(false);
  const [inputValue, setInputValue] = useState(content);

  return (
    <div
      className="inline-flex w-full items-center gap-1 text-content-200"
      onClick={(e) => e.stopPropagation()}
    >
      <Tooltip title={content}>
        <div className="min-w-0 overflow-hidden text-ellipsis line-clamp-2">
          <span>{t('scene.orderWorkspace.returnRefundTab.detail.field.commentContent')}:</span>
          <span>{content}</span>
        </div>
      </Tooltip>
      {showEdit && (
        <>
          <EditOutlined
            onClick={(e) => {
              e.stopPropagation();
              setVisible(true);
            }}
          />
          <Modal
            title={t('scene.orderWorkspace.returnRefundTab.detail.field.commentContent')}
            visible={visible}
            onCancel={() => setVisible(false)}
            onOk={() => {
              updateTradeComment({
                internalTradeId: `${internalTradeId}`,
                sellerMemos: inputValue,
                platform,
              })
                .then(() => {
                  message.success(
                    t('scene.orderWorkspace.returnRefundTab.detail.feedback.updateCommentSuccess'),
                  );
                  onRefresh?.();
                  setVisible(false);
                })
                .catch(() => {
                  message.error(
                    t('scene.orderWorkspace.returnRefundTab.detail.feedback.updateCommentFailed'),
                  );
                });
            }}
          >
            <Input.TextArea
              value={inputValue}
              maxLength={limit}
              autoSize={{ minRows: 4 }}
              showCount
              placeholder={t('scene.orderWorkspace.returnRefundTab.detail.placeholder.comment')}
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
            />
          </Modal>
        </>
      )}
    </div>
  );
};
